<template>
  <div class="humanStatistical" v-if="permisShow('人力统计')">
    <ul class="dataList">
      <li class="dataList_item1">
        <ul class="item_list">
          <li class="list_item_one">
            <div class="one_text">
              <p class="text_number">{{totalNumbers}}</p>
              <p class="text_unit">总员工（人）</p>
            </div>
          </li>
          <li class="list_item_two">
            <div class="one_text">
              <p class="text_number">{{currentMonth}}</p>
              <p class="text_unit">本月入职（人）</p>
            </div>
          </li>
          <li class="list_item_three">
            <div class="one_text">
              <p class="text_number">{{currentYear}}</p>
              <p class="text_unit">本年入职（人）</p>
            </div>
          </li>
          <li class="list_item_four">
            <div class="one_text">
              <p class="text_number">{{currentQuit}}</p>
              <p class="text_unit">本年离职（人）</p>
            </div>
          </li>
        </ul>
      </li>
      <li class="dataList_item2">
        <div class="tiao"></div>
        <ul class="wrap">
          <li class="wrap_item">
            <template>
              <ve-pie :data="sexRatio" :extend="chartExtend" height="370px"></ve-pie>
              <h3>性别比例</h3>
            </template>
          </li>
          <li class="wrap_item">
            <template>
              <ve-pie :data="ageRatio" :extend="chartExtend" height="370px"></ve-pie>
              <h3>年龄占比</h3>
            </template>
          </li>
          <li class="wrap_item">
            <template>
              <ve-pie :data="certificateRatio" :extend="chartExtend" height="370px"></ve-pie>
              <h3>证书占比</h3>
            </template>
          </li>
        </ul>
        <div class="tiao1"></div>
      </li>
      <li class="dataList_item3">
        <h3>
          <div>岗位分布</div>
          <el-input @focus="departpopshow=!departpopshow" v-model="parentName" @clear="clearDepartment" clearable
            placeholder="请选择所在部门"></el-input>
          <div class="departpop" v-show="departpopshow">
            <el-tree :default-expand-all="true" :data="departmentList" :props="defaultProps"
              @node-click="handleNodeClick">
              <span class="custom-tree-node" slot-scope="{ node,data}">
                <div>
                  <img class="tree-icon" v-if="data.labelName=='区'" src="../../assets/icon/quyu.png" alt />
                  <img class="tree-icon" v-if="data.labelName=='店'" src="../../assets/icon/dian.png" alt />
                  <img class="tree-icon" v-if="data.labelName=='组'" src="../../assets/icon/zu.png" alt />
                  <span>{{ data.name }}</span>
                </div>
              </span>
            </el-tree>
          </div>
        </h3>
        <template>
          <ve-histogram :data="roleStatistic" :settings="roleStatisticSet" :extend="chartExtendline"></ve-histogram>
        </template>
      </li>
      <li class="dataList_item4">
        <h3>
          <div>人员变化情况</div>
          <div>
            <el-select v-model="year" @change="queryEmployeeChangeStatistic" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>年
          </div>
        </h3>
        <template>
          <ve-line :data="changeEmployeelist" :settings="changeEmployeelistSet" :extend="chartExtendline"></ve-line>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  queryEmployeeStatistic,
  queryEmployeeRoleStatistic,
  queryEmployeeChangeStatistic
} from "@/api/houseStatistical";
import { departmentFind } from "@/api/manageCenter";
export default {
  data() {
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    let date = new Date();
    this.chartExtend = {
      legend: {
        top: "20px"
      },
      series: {
        center: ["50%", "50%"]
      }
    };

    this.chartExtendline = {
      legend: {
        top: "5%"
      },
      grid: {
        x: 10,
        y: 60
      }
    };
    this.chartExtendline1 = {
      legend: {
        top: "5%"
      },
      grid: {
        x: 20,
        y: 60
      }
    };
    this.changeEmployeelistSet = {
      labelMap: {
        date: "日期",
        entryAmount: "入职",
        quitAmount: "离职",
        totalAmount: "总人数"
      }
    };
    this.roleStatisticSet = {
      labelMap: {
        amount: "人数"
      }
    };
    return {
      permisList,
      data: {
        year: date.getFullYear(), //年
        month: date.getMonth() + 1 //月
      },

      options: [
        {
          value: "2019",
          label: "2019"
        },
        {
          value: "2020",
          label: "2020"
        },
        {
          value: "2021",
          label: "2021"
        },
        {
          value: "2022",
          label: "2022"
        },
        {
          value: "2023",
          label: "2023"
        },
        {
          value: "2024",
          label: "2024"
        },
        {
          value: "2025",
          label: "2025"
        },
        {
          value: "2026",
          label: "2026"
        },
        {
          value: "2027",
          label: "2027"
        },
        {
          value: "2028",
          label: "2028"
        }
      ],

      currentMonth: "",
      currentQuit: "",
      currentYear: "",
      totalNumbers: "",

      // 性别比例
      sexRatio: {
        columns: ["name", "amount"],
        rows: []
      },
      // 年龄占比
      ageRatio: {
        columns: ["name", "amount"],
        rows: []
      },
      // 证书占比
      certificateRatio: {
        columns: ["name", "amount"],
        rows: []
      },

      // 岗位分布
      roleStatistic: {
        columns: ["name", "amount"],
        rows: []
      },
      departpopshow: false,
      parentName: "",
      departmentId: "",
      defaultProps: {
        children: "child"
      },
      departmentList: [],
      // 人员变化情况
      changeEmployeelist: {
        columns: ["date", "entryAmount", "quitAmount", "totalAmount"],
        rows: []
      },
      year: 2020
    };
  },
  mounted() {
    this.queryEmployeeStatistic();
    this.queryEmployeeChangeStatistic();
    this.getdepartmentFindAll();
    this.queryEmployeeRoleStatistic();
  },

  methods: {
    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      console.log(23432343423, result);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },
    queryEmployeeStatistic() {
      this.$post(queryEmployeeStatistic).then(res => {
        if (res.success) {
          this.currentMonth = res.data.currentMonth;
          this.currentQuit = res.data.currentQuit;
          this.currentYear = res.data.currentYear;
          this.totalNumbers = res.data.totalNumbers;
          this.sexRatio.rows = res.data.sexRatio;
          this.ageRatio.rows = res.data.ageRatio;
          this.certificateRatio.rows = res.data.certificateRatio;
        }
      });
    },

    handleNodeClick(node, data) {
      //cosole.log(node)
      this.departmentId = node.id;
      this.parentName = node.name;
      this.queryEmployeeRoleStatistic();
      this.departpopshow = false;
    },

    queryEmployeeRoleStatistic() {
      let params = {
        departmentId: this.departmentId
      };
      this.$post(queryEmployeeRoleStatistic, params).then(res => {
        if (res.success) {
          this.roleStatistic.rows = res.data;
        }
      });
    },

    clearDepartment() {
      this.parentName = "";
      this.departmentId = "";
      this.queryEmployeeRoleStatistic();
    },

    getdepartmentFindAll() {
      this.$post(departmentFind).then(res => {
        if (res.success) {
          this.departmentList = res.data;
          this.parentName = this.departmentList[0].name;
          this.departmentId = this.departmentList[0].id;
        }
      });
    },

    queryEmployeeChangeStatistic() {
      let params = {
        year: this.year
      };
      this.$post(queryEmployeeChangeStatistic, params).then(res => {
        if (res.success) {
          this.changeEmployeelist.rows = res.data.list;
        }
      });
    }
  }
};
</script>

<style lang='less'>
.humanStatistical {
  width: 100%;
  .dataList {
    padding: 14px;
    .dataList_item1 {
      background: #fff;
      overflow: hidden;
      padding: 25px 20px;
      .item_time {
        padding-bottom: 24px;
        .el-select {
          .el-input {
            width: 100px;
            .el-input__inner {
              height: 30px;
              background: #f5f5f5;
              border: none;
            }
            .el-input__icon {
              line-height: 30px;
            }
          }
        }
        .item_time_unit {
          padding: 0 10px;
        }
      }
      .item_list {
        display: flex;
        justify-content: space-between;
        .list_item_one {
          flex: 1;
          border-left: 5px solid #ffffff;
          border-right: 5px solid #ffffff;
          height: 130px;
          background: url(../../assets/statisticalManage/renli-01.png) no-repeat;
          background-size: cover;
          border-radius: 6px;
          .one_text {
            width: 122px;
            position: relative;
            padding-top: 32px;
            margin: 0 auto;
            color: #fff;
            .text_number {
              font-size: 20px;
              margin-bottom: 10px;
            }
            .text_unit {
              font-size: 15px;
            }
          }
        }
        .list_item_two {
          flex: 1;
          border-left: 5px solid #ffffff;
          border-right: 5px solid #ffffff;
          height: 130px;
          background: url(../../assets/statisticalManage/renli-02.png) no-repeat;
          background-size: cover;
          border-radius: 6px;
          .one_text {
            width: 122px;
            position: relative;
            padding-top: 32px;
            margin: 0 auto;
            color: #fff;
            .text_number {
              font-size: 20px;
              margin-bottom: 10px;
            }
            .text_unit {
              font-size: 15px;
            }
          }
        }
        .list_item_three {
          flex: 1;
          border-left: 5px solid #ffffff;
          border-right: 5px solid #ffffff;
          height: 130px;
          background: url(../../assets/statisticalManage/renli-03.png) no-repeat;
          background-size: cover;
          border-radius: 6px;
          .one_text {
            width: 122px;
            position: relative;
            padding-top: 32px;
            margin: 0 auto;
            color: #fff;
            .text_number {
              font-size: 20px;
              margin-bottom: 10px;
            }
            .text_unit {
              font-size: 15px;
            }
          }
        }
        .list_item_four {
          flex: 1;
          border-left: 5px solid #ffffff;
          border-right: 5px solid #ffffff;
          height: 130px;
          background: url(../../assets/statisticalManage/renli-04.png) no-repeat;
          background-size: cover;
          border-radius: 6px;
          .one_text {
            width: 122px;
            position: relative;
            padding-top: 44px;
            margin: 0 auto;
            color: #fff;
            .text_number {
              font-size: 20px;
              margin-bottom: 10px;
            }
            .text_unit {
              font-size: 15px;
            }
          }
        }
      }
    }
    .dataList_item2 {
      position: relative;
      .tiao {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 100%;
        background: #fff;
      }
      .tiao1 {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 20px;
        width: 100%;
        background: #fff;
      }
      .wrap {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        .wrap_item {
          background: #fff;
          width: 32.8%;
          overflow: hidden;
          h3 {
            text-align: center;
            font-size: 16px;
            font-weight: bold;
            padding-bottom: 30px;
          }
        }
      }
    }
    .dataList_item3 {
      margin-top: 10px;
      padding: 20px;
      background: #fff;
      h3 {
        font-size: 16px;
        padding-bottom: 20px;
        font-weight: bold;
        border-bottom: 1px solid #e1e1e1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        .departpop {
          width: 170px;
          position: absolute;
          right: 10px;
          top: 41px;
          z-index: 10;
          border: 1px solid #eee;
          .tree-item {
            display: flex;
            align-items: center;
            img {
              padding-right: 10px;
            }
          }
        }
        .el-input {
          width: 200px;
          margin: 0 8px;
          .el-input__icon {
            line-height: 30px;
          }
          .el-input__inner {
            width: 200px;
            height: 30px;
            background: rgba(245, 245, 245, 1);
            border-radius: 4px;
          }
        }
      }
    }
    .dataList_item4 {
      margin-top: 10px;
      padding: 20px;
      background: #fff;
      h3 {
        font-size: 16px;
        padding-bottom: 20px;
        font-weight: bold;
        border-bottom: 1px solid #e1e1e1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .el-select {
          margin: 0 8px;
          .el-input__icon {
            line-height: 30px;
          }
          .el-input__inner {
            width: 100px;
            height: 30px;
            background: rgba(245, 245, 245, 1);
            border-radius: 4px;
          }
        }
      }
    }
  }
}
</style>